import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "userButton"]

  connect() {
    // Focus search input on page load
    if (this.hasSearchTarget) {
      this.searchTarget.focus()
    }
  }

  filterUsers(event) {
    const query = event.target.value.toLowerCase().trim()

    this.userButtonTargets.forEach(button => {
      const searchText = button.dataset.userSearch || ""
      const matches = searchText.includes(query)
      button.style.display = matches ? "" : "none"
    })
  }

  selectUser(event) {
    // Update selection styling
    this.userButtonTargets.forEach(btn => {
      btn.classList.remove("bg-bg-active")
      btn.style.borderLeftColor = "transparent"
    })
    event.currentTarget.classList.add("bg-bg-active")
    event.currentTarget.style.borderLeftColor = "rgb(1 197 209)" // brand-500
  }
}
